// Contains data for constructing an info.yml file. 

export default function getInitialData(){
  return ({
  DOI: null,
  TRJ: null,
  BinaryTopology: null,
  SOFTWARE: null,
  PREEQTIME: null,
  TIMELEFTOUT: null,
  UNITEDATOM_DICT: {},
  TEMPERATURE: null,
  SYSTEM: null,
  PUBLICATION: null,
  AUTHORS_CONTACT: null,
  SOFTWARE_VERSION: null,
  FF: null,
  FF_SOURCE: null,
  FF_DATE: null,
  CPT: null,
  LOG: null,
  TOP: null,
  EDR: null,
  LIPID_COMPOSITION: {},
  SOLUTION_COMPOSITION: {}
});
}; 